var _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarSquareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6447",
    "data-name": "Groupe 6447",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3491",
    "data-name": "Rectangle 3491",
    fill: "#f4deff",
    stroke: "#956ae1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 86,
    rx: 5.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5709",
    "data-name": "Trac\\xE9 5709",
    d: "M31.79,2.2a3.18,3.18,0,0,0-6.023-.079H21.091a3.18,3.18,0,0,0-6,0H10.419A3.18,3.18,0,0,0,4.4,2.2,5.308,5.308,0,0,0,0,7.421V33.006a3.184,3.184,0,0,0,3.18,3.18H33.006a3.184,3.184,0,0,0,3.18-3.18V7.421A5.308,5.308,0,0,0,31.79,2.2M28.765,2.12a1.061,1.061,0,0,1,1.06,1.06V5.3a1.06,1.06,0,0,1-2.12,0V3.18a1.061,1.061,0,0,1,1.06-1.06m-10.672,0a1.061,1.061,0,0,1,1.06,1.06V5.3a1.06,1.06,0,1,1-2.12,0V3.18a1.061,1.061,0,0,1,1.06-1.06m-10.672,0a1.061,1.061,0,0,1,1.06,1.06V5.3a1.06,1.06,0,1,1-2.12,0V3.18a1.061,1.061,0,0,1,1.06-1.06m-5.3,5.3a3.185,3.185,0,0,1,2.12-3V5.3a3.18,3.18,0,1,0,6.361,0V4.241h4.311V5.3a3.18,3.18,0,1,0,6.361,0V4.241h4.311V5.3a3.18,3.18,0,0,0,6.361,0V4.423a3.185,3.185,0,0,1,2.12,3v3.251H2.12ZM34.066,33.006a1.061,1.061,0,0,1-1.06,1.06H3.18a1.061,1.061,0,0,1-1.06-1.06V12.792H34.066Z",
    transform: "translate(25.443 25.443)",
    fill: "#956ae1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5710",
    "data-name": "Trac\\xE9 5710",
    d: "M125.241,251.6a2.123,2.123,0,0,1-2.12-2.12,1.06,1.06,0,1,0-2.12,0,4.241,4.241,0,1,0,5.537-4.038l2.633-2.633a1.061,1.061,0,0,0-.75-1.81H122.06a1.06,1.06,0,0,0,0,2.12h3.8l-2.431,2.431a1.061,1.061,0,0,0,.75,1.81h1.06a2.12,2.12,0,1,1,0,4.241",
    transform: "translate(-87.004 -198.524)",
    fill: "#956ae1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5711",
    "data-name": "Trac\\xE9 5711",
    d: "M272.06,251.588a1.06,1.06,0,0,0,0,2.12h8.481a1.06,1.06,0,1,0,0-2.12h-3.18v-9.541a1.061,1.061,0,0,0-1.81-.75l-4.241,4.241a1.06,1.06,0,1,0,1.5,1.5l2.431-2.431v6.982Z",
    transform: "translate(-226.402 -198.51)",
    fill: "#956ae1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSquareIcon);
export default __webpack_public_path__ + "static/media/calendar-square-icon.838c33fee0c27edb8ddb6575f8bab031.svg";
export { ForwardRef as ReactComponent };